import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  danger: {
    color: theme.palette.error.main,
  },
}))
